import axios, { AxiosInstance } from 'axios';

const api: AxiosInstance = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('geoz_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const cityId = localStorage.getItem('geoz_city_id');
  if (cityId) {
    config.headers['X-City-Id'] = cityId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const publicPaths = ['/auth/login', '/auth/register', '/auth/verify', '/auth/forgot-password', '/auth/reset-password'];
    if (error.response?.status === 401 && !publicPaths.includes(error.config?.url || '')) {
      localStorage.removeItem('geoz_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default api;